module.exports = __webpack_public_path__ + "assets/ligapontos-dir.74707d5d.svg";